import Vue from 'vue'
import Message from './index.vue'

const MessageConstructor = Vue.extend(Message)

let messageInstance = null

const MessagePlugin = {
  install(Vue) {
    Vue.prototype.$toast = {
      show(options) {
        if (messageInstance) {
          messageInstance.close()
        }
        
        messageInstance = new MessageConstructor({
          data: options
        })
        
        messageInstance.$mount()
        document.body.appendChild(messageInstance.$el)
        messageInstance.visible = true
        
        return messageInstance
      },
      
      success(message, duration = 2000) {
        return this.show({
          message,
          type: 'success',
          duration,
          icon: 'el-icon-success'
        })
      },
      
      error(message, duration = 2000) {
        return this.show({
          message,
          type: 'error',
          duration,
          icon: 'el-icon-error'
        })
      },
      
      warning(message, duration = 2000) {
        return this.show({
          message,
          type: 'warning',
          duration,
          icon: 'el-icon-warning'
        })
      },
      
      info(message, duration = 2000) {
        return this.show({
          message,
          type: 'info',
          duration,
          icon: 'el-icon-info'
        })
      }
    }
  }
}

export default MessagePlugin 